import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
    selector: '[fullNameDirective]',
})
export class FullNameDirective {
    constructor(private el: ElementRef) {}
    @HostListener('input', ['$event'])
    onInput(): void {
        const inputElement: HTMLInputElement = this.el
            .nativeElement as HTMLInputElement;
        const value: string = inputElement.value;
        // Remove any characters that are not alphabets or spaces
        const sanitizedValue: string = value.replace(
            /[^a-zA-Z0-9\s&\-'_@+]/g,
            '',
        );

        inputElement.value = sanitizedValue;
    }
}
